// rowsMore: which ends of the places list still hold more rows (pure, so it is
// tested cold). The list shows five rows and a half and scrolls inside itself,
// with a soft fade at an end that has more and none where it does not. Five rows
// or fewer neither scroll nor fade. The numbers come straight off the scroller.

export interface RowsMore {
  /** the list is taller than its box, so it scrolls */
  scroll: boolean;
  /** rows wait above the first one shown */
  top: boolean;
  /** rows wait below the last one shown */
  bottom: boolean;
}

/** a row's worth of pixels is never "more": sub-pixel rounding must not light a fade */
const SLACK = 2;

export function rowsMore(scrollTop: number, clientHeight: number, scrollHeight: number): RowsMore {
  const scroll = scrollHeight - clientHeight > SLACK;
  if (!scroll) return { scroll: false, top: false, bottom: false };
  return {
    scroll: true,
    top: scrollTop > SLACK,
    bottom: scrollTop + clientHeight < scrollHeight - SLACK,
  };
}
